import React, {useEffect, useState, useCallback} from 'react';
import MediumOutlineButton from "@/components/general/buttons/MediumOutlineButton";
import BlueButton from "@/components/general/buttons/BlueButton";
import {useRouter} from "next/router";
import {useAuth} from "@/libs/auth";
import {processEpoch} from "@/utils/date";
import {classNames} from "@/utils/general";
import {getSubscription, querySubscription, retrieveProduct} from "@/services/stripe-store";
import LoadingDots from "@/components/general/LoadingDots";
import {getUsage} from "@/services/usage-store";

function CreditUsage({cid}: { cid: string }) {
    const router = useRouter();
    const {projectId} = router.query;
    const {uid, token} = useAuth();
    const [creditUsage, setCreditUsage] = useState(-1)
    const [billingPeriod, setBillingPeriod] = useState<number[]>([]);

    useEffect(() => {
        if (!uid) return;

        querySubscription(token, cid)
            .then(res => {
                setBillingPeriod([res.data.current_period_start, res.data.current_period_end])
                return getUsage(token, res.data.current_period_start, res.data.current_period_end, projectId as string)
            })
            .then(res => setCreditUsage(res.data.credits));
    }, [uid])

    const billingPeriodText = billingPeriod
        .map(epoch => processEpoch(epoch, 'MMM D'))
        .join(' - ');

    return <p className="text-gray-400 mb-2">
        Current estimated credit usage for this billing period ({billingPeriod ? billingPeriodText : <LoadingDots />}):&nbsp;
        {creditUsage < 0
            ? <LoadingDots/>
            : <span className="text-red-500">{creditUsage.toLocaleString()} Credits</span>}
    </p>
}

export default CreditUsage;
